import { CONTENT_TYPE, REQUEST_TYPES } from "../constants/api.js";
import { ENDPOINTS } from "../constants/api.js";
import store from "../state/store/Store.js";

import { encodeURIData, sanitiseBody, consoleLogger } from "./apiUtils.js";

// -- FETCH FUNTIONALITY -- //

function callApi(endpoint, method, contentType, tokens, body, accept) {
  let fullUrl = store.getState().config.data.API_URI + endpoint;
  let sanitisedBody = sanitiseBody(method, body);

  // manage request headers
  const options = {
    method,
    credentials: "include",
    headers: {
      "Content-Type": contentType,
      Accept: accept || "*/*"
    }
  };

  if (tokens.token) {
    options.headers.Authorization = `Bearer ${tokens.token}`;
  }

  // manage param encoding for different request types
  if (sanitisedBody && sanitisedBody !== null) {
    if (method === REQUEST_TYPES.GET || method === REQUEST_TYPES.DELETE) {
      fullUrl = `${fullUrl}?${encodeURIData(sanitisedBody)}`;
    } else {
      options.body = JSON.stringify(sanitisedBody);
    }
  }

  // api call log - prevent username/password logging
  // consoleLogger(method, fullUrl, sanitisedBody);
  consoleLogger(method, fullUrl); // rekoved object logging for now to prevent leaky passwords

  return doFetch(fullUrl, options);
}

function doFetch(fullUrl, options) {
  return fetch(fullUrl, options)
    .then(response => {
      if (!response.ok) {
        throw response;
      }
      return response;
    })
    .then(response => ({ response }))
    .catch(error => {
      console.log("api :: doFetch :: error ::", error);
      if (error.status) {
        return { error };
      } else {
        // Bad gateway, eg. API out of PHP-FPM workers
        return {
          error: new Response("Generated 502: Bad gateway", {
            status: 502,
            statusText: "Bad gateway"
          })
        };
      }
    });
}

// -- AUTHENTICATION CALLS -- //

export const doRefreshCall = (tokens, body) => {
  const { refresh_token } = tokens;
  if (!body && refresh_token) {
    body = { refresh_token };
  }

  return callApi(
    ENDPOINTS.REFRESH_AUTHENTICATION,
    REQUEST_TYPES.POST,
    CONTENT_TYPE.JSON,
    tokens,
    body
  );
};

// -- GENERIC ENTITY -- //

export const getEntitiesCall = (tokens, body) => {
  return callApi(
    body.endpoint,
    REQUEST_TYPES.GET,
    CONTENT_TYPE.JSON_LD,
    tokens,
    body
  );
};

export const getEntityCall = (tokens, body) => {
  return callApi(
    body["@id"],
    REQUEST_TYPES.GET,
    CONTENT_TYPE.JSON_LD,
    tokens,
    body
  );
};

export const getPDFCall = (tokens, body) => {
  return callApi(
    body["@id"],
    REQUEST_TYPES.GET,
    CONTENT_TYPE.JSON_LD,
    tokens,
    body,
    CONTENT_TYPE.PDF
  );
};

export const getTXTCall = (tokens, body) => {
  return callApi(
    body["@id"],
    REQUEST_TYPES.GET,
    CONTENT_TYPE.JSON_LD,
    tokens,
    body,
    CONTENT_TYPE.TXT
  );
};

export const createEntityCall = (tokens, body) => {
  return callApi(
    body.endpoint,
    REQUEST_TYPES.POST,
    CONTENT_TYPE.JSON_LD,
    tokens,
    body
  );
};

export const updateEntityCall = (tokens, body) => {
  return callApi(
    body["@id"],
    REQUEST_TYPES.PUT,
    CONTENT_TYPE.JSON_LD,
    tokens,
    body
  );
};

// deleteEntityCall has been removed in favour of an operationsCall

export const operationsCall = (tokens, body) => {
  return callApi(body.href, body.method, body.type, tokens, body.fields);
};
